// saber
// @author CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @create 2020/08/30 12:28
import { defaultPreHandler, adapter, printLogger } from './middlewares';
import { createApplyChain } from './utils';
let instance = null;
export class Saber {
    /** 单例模式 */
    static singleton() {
        if (instance)
            return instance;
        instance = new Saber();
        return instance;
    }
    constructor() {
        this._middlewares = [];
        this._middlewareMap = new Map();
        this.use(printLogger, Number.MIN_SAFE_INTEGER);
        this.use(defaultPreHandler, Number.MIN_SAFE_INTEGER + 10);
        this.use(adapter, Number.MAX_SAFE_INTEGER);
    }
    /**
     * 注册中间件
     * @param middleware
     * @param order 调用顺序，默认按添加的顺序
     */
    use(middleware, order = this._middlewares.length * 10) {
        if (typeof middleware !== 'function') {
            throw new TypeError('middleware must be a function.');
        }
        this._middlewares.push(middleware);
        this._middlewareMap.set(middleware, order);
        this.sortMiddlewares(this._middlewares);
        this._invoker = undefined;
        return this;
    }
    /**
     * @param api 数据接口
     * @param options 请求参数
     * @param middlewares 临时添加中间件
     */
    async request(api, options, middlewares) {
        const { response } = await this.run(api, options, middlewares);
        return response;
    }
    run(api, options, middlewares) {
        if (options && Reflect.has(options, 'next')) {
            throw new Error('Illegal property: "next"');
        }
        // 支持临时添加中间件
        if (middlewares === null || middlewares === void 0 ? void 0 : middlewares.length) {
            const execMiddlewares = this.sortMiddlewares([...this._middlewares, ...middlewares]);
            return createApplyChain(execMiddlewares, this).call(this, Object.assign({ api }, (options || {})));
        }
        this._invoker = this._invoker || createApplyChain(this._middlewares, this);
        return this._invoker(Object.assign({ api }, (options || {})));
    }
    /** 根据 order 给中间件排序 */
    sortMiddlewares(middlewares) {
        middlewares.forEach((md, index) => {
            if (this._middlewareMap.get(md) === undefined) {
                this._middlewareMap.set(md, index * 10);
            }
        });
        middlewares.sort((a, b) => {
            return this._middlewareMap.get(a) - this._middlewareMap.get(b);
        });
        return middlewares;
    }
}
